<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="modalReference.close()">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="text-center mb-4">
            <span class="modal-title"> {{ 'CHANGE_LANG_MODAL.TITLE' | translate }} </span>
        </div>
        <form role="form" [formGroup]="form" novalidate>
            <ng-select [dropdownPosition]="'bottom'" bindValue="id" bindLabel="name" [clearable]="false" [items]="langList" [searchable]="false" [multiple]="false" formControlName="languages">
            </ng-select>
        </form>
        <div class="d-flex justify-content-center mt-4">
            <button type="button" class="modal-ok-btn" ngbAutofocus (click)="setLang()">
                {{ 'CONSTANTS.BTN_SAVE' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>